import { ModalFooter } from 'reactstrap'
import React from 'react'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'

export const CloseFooter = (props) => {
  const { btnColor } = props
  let color = btnColor || 'success'
  return (
    <ModalFooter>
      <Button color={color} onClick={props.closeDialog}>
        <Resx name={props.primaryButtonText || 'Common.Confirm'} />
      </Button>
    </ModalFooter>
  )
}



// WEBPACK FOOTER //
// ./src/dialogs/common/closeFooter.js